export default "__VITE_ASSET__CRg3F8UL__"